import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// サイト全体の言語はここが単一の真実。ページごとに state を持たない
// （かつて /lyrics と /liner-notes がそれぞれ useState を持っており、ページを移ると
//  言語が飛んでいた。2026-08-15 に Navbar のトグルへ統合した）。
//
// **初期言語は常に英語** [酒井 2026-08-15]。ブラウザ言語も localStorage も見ない
// （i18next-browser-languagedetector は依存ごと削除した）。よって**選択はリロードで
//  英語に戻る**。永続化したくなったら changeLanguage 時に localStorage へ書き、
//  ここで読むだけでよい（依存を戻す必要は無い）。
//
// keySeparator / nsSeparator を無効にしているのは、リソースを**フラットな1階層**で
// 持つため（`nav.top` は入れ子ではなくキーそのもの）。ローダ local/index.ts が
// Record<string, string> を前提にしているのと揃えてある。

export const SUPPORTED_LANGUAGES = ['en', 'ja'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    debug: false,
    resources: messages,
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
